import type { ILayer, BlendMode, CanvasLike, TextData } from './types';

/**
 * @class LayerClass
 * @description Represents a single drawing layer with its own canvas context.
 */
export class LayerClass implements ILayer {
  public name: string;
  public canvas: CanvasLike;
  public ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D;
  public visible: boolean;
  public opacity: number;
  public blendMode: BlendMode;
  public locked: boolean;
  public type: ILayer['type'];
  public textData: TextData;
  public shapes?: import('./types').Shape[];
  public isBeingEdited?: boolean;

  constructor(name = 'Layer', width: number, height: number, createCanvasFn?: (w: number, h: number) => CanvasLike) {
    this.name = name;
    
    if (createCanvasFn) {
      this.canvas = createCanvasFn(width, height);
    } else {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      this.canvas = canvas;
    }

    // createCanvas returns CanvasLike; getContext('2d') is guaranteed to work
    const ctx = (this.canvas as HTMLCanvasElement).getContext('2d') ??
      (this.canvas as OffscreenCanvas).getContext('2d');
      
    if (!ctx) throw new Error('Failed to get 2D context for layer canvas');
    this.ctx = ctx;
    
    this.visible = true;
    this.opacity = 1.0;
    this.blendMode = 'source-over';
    this.locked = false;
    this.type = 'raster';
    this.textData = {
      text: '', x: 0, y: 0,
      font: 'Roboto', size: 40, color: '#000000',
      bold: false, italic: false,
    };
  }
}
